import '../cart/cart-summary';
import '../input/button-input';

import{ html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { Prop } from '../cart/cart-summary';

import { FormElement } from './form';

@customElement('cart-form')
export class CartForm extends FormElement {

    // Lifecycle Hooks

    firstUpdated() {
        
        // first updated
        this.classList.add('Form','Form--cart');
    }

    // Render

    render() {
        const props: Prop[] = [
            { label: 'Subtotal', name: 'itemSubtotalAsCurrency' },
        ];
        return html`
            <form action="/checkout">
                <header class="Form-header">
                    <cart-summary
                        .props="${ props }"
                    ></cart-summary>
                </header>
                <div class="Form-body">
                    ${ this.submitButtonTemplate('submit', 'Checkout') }
                </div>
            </form>
        `;
    }

    createRenderRoot() { 
        return this;
    }

}